module.exports = __webpack_public_path__ + "static/media/SEVEN.82081b8d.png";